export const PROVIDER_ORDER = ['fn', 'wm', 'crosscom', 'cloudwork'];

export function normalizeProviderStatusResponse(data = {}) {
  const providers = Array.isArray(data.providers) ? data.providers : [];
  const sortedProviders = configuredProviders(providers).sort((left, right) => {
    const leftIndex = PROVIDER_ORDER.indexOf(left.provider);
    const rightIndex = PROVIDER_ORDER.indexOf(right.provider);
    return orderIndex(leftIndex) - orderIndex(rightIndex);
  });

  return {
    checkedAt: data.checked_at || null,
    status: data.status || 'unknown',
    attentionCount: Number.isFinite(data.attention_count) ? data.attention_count : sortedProviders.filter((provider) => provider.attention_required).length,
    providers: sortedProviders
  };
}

export function providerShortLabel(provider = {}) {
  return provider.short_label || initials(provider.label || provider.provider || 'Provider');
}

export function providerColor(provider = {}) {
  if (provider.severity === 'success') return 'success';
  if (provider.severity === 'error') return 'error';
  if (provider.severity === 'info') return 'info';
  return 'warning';
}

export function providerChipLabel(provider = {}) {
  return providerShortLabel(provider);
}

export function configuredProviders(providers = []) {
  return providers.filter((provider) => provider.configured !== false && provider.has_credentials !== false);
}

function orderIndex(index) {
  return index === -1 ? PROVIDER_ORDER.length : index;
}

function initials(value) {
  const words = String(value)
    .trim()
    .split(/[\s_-]+/)
    .filter(Boolean);
  if (!words.length) return 'NA';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return words
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}
